import { TaxRate, TaxRateQuery } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';

export const useCqrsSearchTaxRate = (): UseCqrsQueryResult<TaxRate[]> => {
   return useCqrsSearch<TaxRate>(
      () => {
         const query = new TaxRateQuery();
         return query;
      },
      paginations.all(),
      {
         cacheTime: 'long',
      }
   );
};
